import React from "react";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import Cookies from "js-cookie";
import api from "../../api/index";
import { Trans, useTranslation } from 'react-i18next';

function NewGame() {
  const { t } = useTranslation();

  const NewGameSchema = Yup.object().shape({
    grade: Yup.number()
      .min(1)
      .max(3)
      .required(t("teacher.new_game.grade_required")),
    players: Yup.number()
      .typeError(t("teacher.new_game.players_type_error"))
      .integer(t(
        "teacher.new_game.players_integer"
      ))
      .positive(t("teacher.new_game.players_positive"))
      .min(3, t("teacher.new_game.players_min"))
      .max(50, t("teacher.new_game.players_max"))
      .required(t("teacher.new_game.players_required")),
    timeLimit: Yup.number()
      .min(1)
      .max(240)
      .required('Required')
  });

  let handleSubmit = (values, { setSubmitting }) => {
    api.createNewGame(values.grade, values.players, values.timeLimit).then((response) => {
      if (response.status === 200) {
        const data = response.data;
        Cookies.set("game_id", data.secret);
        Cookies.set("game_code", data.game_code);
        setSubmitting(false);
        window.location.href = `/app/teacher/monitor/${data.secret}`;
      }
    });
  };

  return (
    <div className="mobileContainer teacher-onboard-screen">
      <Formik
        initialValues={{ grade: '1', players: 3, timeLimit: 45 }}
        validationSchema={NewGameSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          isValid
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="content-wrapper">
              <div className="content">
                <h3>{t('teacher.new_game.title')}</h3>
                <p><Trans i18nKey="teacher.new_game.content_1" components={[<u />]} /></p>
                <p>{t("teacher.new_game.content_2")}</p>
                <div className="form-wrapper">
                  {/* <div className="radio-wrapper">
                  <div>
                    <label>{t("teacher.new_game.game_type")}</label>
                  </div>
                  <div role="group">
                  <label>
                    <Field type="radio" name="grade" value="1" />
                    {t("teacher.new_game.game_type_1")}
                  </label>
                  <label>
                    <Field type="radio" name="grade" value="2" />
                    {t("teacher.new_game.game_type_2")}
                  </label>
                  </div>
                  <p>
                    {errors.grade && touched.grade && errors.grade}
                  </p>
                </div>               */}
                  <input
                    type="hidden"
                    name="grade"
                    value={values.grade}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                  
                  <div className="input-wrapper">
                  <label>{t("teacher.new_game.number_of_student")}</label>
                    <input
                      type="text"
                      name="players"
                      value={values.players}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </div>
                  <p>
                    {errors.players && touched.players && errors.players}
                  </p>
                  
                  <div className="input-wrapper">
                  <label>{t("teacher.new_game.play_time")}</label>
                    <input
                      type="text"
                      name="timeLimit"
                      value={values.timeLimit}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <button type="submit" className={`continue-button ${!isValid || isSubmitting ? 'invalid' : ''}`} disabled={!isValid || isSubmitting}>
                  <div className="label">{t("teacher.new_game.start_game")}</div>
                </button>
              </div>
              <a className="footer-wrapper" href="https://www.medievalme.nl" target="_blank">
                {t("teacher.new_game.back_to_explanation")}
              </a>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default NewGame;